var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconDiscussions = function SvgIconDiscussions(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.718 18.561 6.78 5.311c.111.085.179.128.245.128.188 0 .244-.127.244-.338v-5.023c0-.355.233-.637.548-.637L21 18c2.219 0 3-1.094 3-2V2c0-1-.748-2-3.014-2H2.989C.802 0 0 .969 0 2v14c0 .969.828 2 3 2h6s1.255.035 1.718.561"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconDiscussions);
export { ForwardRef as ReactComponent };